import styled from 'styled-components';

import { alignCenter } from '../../styles/utils/positioning';

const yMargins = '30px';
const xMargins = '60px';

export const SBContainer = styled.div`
  max-width: 80%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  z-index: 9999;

  &.bottom {
    bottom: ${yMargins};
    ${alignCenter('fixed')}
  }

  &.bottomLeft {
    left: ${xMargins};
    bottom: ${yMargins};
    align-items: flex-start;
  }

  &.bottomRight {
    right: ${xMargins};
    bottom: ${yMargins};
    align-items: flex-end;
  }

  &.top {
    top: ${xMargins};
    ${alignCenter('fixed')}
  }

  &.topLeft {
    left: ${xMargins};
    top: ${yMargins};
    align-items: flex-start;
  }

  &.topRight {
    right: ${xMargins};
    top: ${yMargins};
    align-items: flex-end;
  }
`;
